// Translation constants
export const SAVESUCCESS = 'SavedSuccessfuly';
export const EDITSUCCESS = 'EditedSuccessfuly';
export const DELETESUCCESS = 'DeletedSuccessfuly';
export const OPERERROR = 'OperationFailed';
export const NODATAFOUND = 'NoDataFound';
export const ADDSUCCESS = 'AddedSuccessfully';
export const ADDTOFAV = 'AddFav';
export const REMOVEVEF = 'RemoveFav';

export const TabConst = {
    // === Direction ===
    RTL: 'rtl',
    LTR: 'ltr',
  
    // === Layout Types ===
    VERTICAL: 'vertical',
    HORIZONTAL: 'horizontal',
    COMPACT: 'compact',
  DefaultSize: 'compact',
    // === Breakpoints ===
    MIN_WIDTH_1400PX: '(min-width: 1400px)',
    MAX_WIDTH_1399PX: '(max-width: 1399.98px)',
    MIN_WIDTH_1025PX: '(min-width: 1025px)',
    MAX_WIDTH_1024PX: '(max-width: 1024.98px)',
  
    // === Notifications ===
    RECEIVE_NOTIFICATION: 'ReceiveNotification',
  
    // === Operation Messages ===
    SAVESUCCESS: 'SavedSuccessfully',
    EDITSUCCESS: 'EditedSuccessfully',
    DELETESUCCESS: 'DeletedSuccessfully',
    ADDSUCCESS: 'AddedSuccessfully',
    OPERERROR: 'OperationFailed',
    NODATAFOUND: 'NoDataFound',
    ADDTOFAV: 'AddFav',
    REMOVEFAV: 'RemoveFav',

    // === default input size ===
    DEFAULTSIZE: 'compact',
  } as const;
  
  
  